/**
 * RappelLoiBanner — item 2.4 du retour mairie.
 *
 * « Bandeau de rappel à la loi sous les champs d'envoi d'images/textes. »
 *
 * ─── CE QU'IL EST, ET CE QU'IL N'EST PAS ────────────────────────────────────
 *
 * C'est ce qui RESTE de l'arbitrage D1 : la mairie voulait une modération IA des
 * zones de texte, la décision a été NON (un-contre-un ≠ diffusion de masse). Ce
 * bandeau est « la seule mesure retenue ».
 *
 * ⇒ Il ne modère rien, ne bloque rien, ne valide rien. Il RAPPELLE. C'est un
 *   dispositif de prévention, pas un contrôle — et c'est exactement ce qui a été
 *   décidé.
 *
 * ─── LE TEXTE APPARTIENT À LA COMMUNE ───────────────────────────────────────
 *
 * `tenants.rappel_loi_texte` (mig. 201), réglable dans Administration →
 * Paramètres. **Vide par défaut, volontairement** : ce texte engage la commune
 * qui l'affiche, pas l'éditeur. On ne met pas nos mots sous la signature d'une
 * mairie.
 *
 * ⇒ Si le champ est vide, le composant ne rend RIEN. Pas de bandeau fantôme,
 *   pas de cadre vide.
 *
 * Usage :
 *   <RappelLoiBanner />                    // sous un <textarea>
 *   <RappelLoiBanner className="mt-3" />
 */

import { Info } from 'lucide-react';
import { useAuth } from '@/lib/auth-context';

interface RappelLoiBannerProps {
  /** Classes additionnelles (marges du contexte d'appel). */
  className?: string;
}

export function RappelLoiBanner({ className = '' }: RappelLoiBannerProps) {
  const { tenant } = useAuth();
  const texte = tenant?.rappelLoiTexte?.trim();

  // Aucun texte configuré = aucun bandeau. Voir l'en-tête : le silence est le
  // défaut voulu, pas un oubli.
  if (!texte) return null;

  return (
    <div
      className={`flex items-start gap-2 rounded-r-md border border-border bg-bg-2/40 px-3 py-2 ${className}`}
      role="note"
    >
      <Info className="mt-0.5 h-3.5 w-3.5 shrink-0 text-ink-subtle" aria-hidden="true" />
      <p className="text-2xs leading-relaxed text-ink-muted">{texte}</p>
    </div>
  );
}
